export function initRating() {
  document.querySelectorAll('[data-rating]').forEach(container => {
    const stars = container.querySelectorAll('[data-star]');
    const input = container.querySelector('input[type="hidden"]');
    let current = parseInt(input?.value || '0');

    function paint(upTo) {
      stars.forEach((s, i) => {
        const icon = s.querySelector('i');
        if (!icon) return;
        if (i < upTo) {
          icon.className = 'fa-solid fa-star text-dcco-accent';
        } else {
          icon.className = 'fa-light fa-star text-gray-300';
        }
      });
    }

    paint(current);

    stars.forEach((star, idx) => {
      star.addEventListener('mouseenter', () => paint(idx + 1));
      star.addEventListener('mouseleave', () => paint(current));
      star.addEventListener('click', () => {
        current = idx + 1;
        if (input) input.value = current;
        paint(current);
        container.dispatchEvent(new CustomEvent('rating-change', { detail: { value: current } }));
      });
    });
  });
}
